export default __webpack_public_path__ + "app/images/0ce6c510b1614afff8c3d082e0261a44.png";